import { render, staticRenderFns } from "./OrderDoc.vue?vue&type=template&id=5a8412ec&scoped=true"
var script = {}
import style0 from "./OrderDoc.vue?vue&type=style&index=0&id=5a8412ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8412ec",
  null
  
)

export default component.exports